import { render } from "./FormatGroupList.vue?vue&type=template&id=bb69dd04"
import script from "./FormatGroupList.vue?vue&type=script&lang=js"
export * from "./FormatGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__